module.exports = __webpack_public_path__ + "img/tutorial_redactions_04.10da45e3.gif";